import { UserInfo } from 'types/state';
import { normalizeSportingUserInfo } from 'services/sporting/utils/normalizeSportingUserInfo';
import { sportingAPI } from 'services/sporting/api';

export const getUserInfo = async (): Promise<UserInfo> => {
  const userInfo = await sportingAPI.service.getUserInfo();

  return normalizeSportingUserInfo.toUserInfo(userInfo);
};
